import UtilsService from './UtilsService';

export const getCustomTeacherTabId = (tab) => `custom:${tab.id}`;

export const isCustomTeacherTabId = (tabId) => (
  typeof tabId === 'string' && tabId.indexOf('custom:') === 0
);

export const getVisibleCustomTeacherTabs = (model) => {
  if (!model || !Array.isArray(model.customTeacherTabs)) {
    return [];
  }
  return model.customTeacherTabs.filter((tab) => tab && !UtilsService.isNullOrEmpty(tab.content));
};

export const hasCustomTeacherTabs = (model) => getVisibleCustomTeacherTabs(model).length > 0;
